import { useParams } from 'react-router-dom';
import { useGetPublicGroupsQuery } from '../../../api/subscribeApi';
import getSubdomain from '../../../utils/getSubdomain';
import GroupTile from '../../../components/GroupTile/GroupTile';
import card from '../../../styles/shared/publicCard.module.css';
import styles from './LandingPage.module.css';

export default function LandingPage() {
  const { organizationSlug: slugFromPath } = useParams();
  const subdomainSlug = getSubdomain();
  const organizationSlug = slugFromPath ?? subdomainSlug;
  const groupPath = (groupId) =>
    subdomainSlug ? `/${groupId}` : `/o/${organizationSlug}/g/${groupId}`;

  const {
    data: groups,
    isLoading,
    isError,
    error,
  } = useGetPublicGroupsQuery(organizationSlug);

  if (isLoading) return <p className={card.status}>Loading…</p>;
  if (isError) {
    const status = error?.status;
    return (
      <p className={card.status}>
        {status === 404
          ? `Organization "${organizationSlug}" not found.`
          : 'Could not load groups. Please try again.'}
      </p>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      <h1 className={styles.title}>What&apos;s on</h1>
      {groups?.length ? (
        <>
          <p className={styles.subtitle}>Pick a group to subscribe 👇</p>
          <div className={styles.grid}>
            {groups.map((group) => (
              <GroupTile
                key={group.id}
                to={groupPath(group.id)}
                imageUrl={group.tile_image_url}
                name={group.name}
              />
            ))}
          </div>
        </>
      ) : (
        <p className={card.status}>No groups are open right now. Check back later.</p>
      )}
    </div>
  );
}
